import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import MaskedInput from "react-text-mask";
const MaskedDateInput = (props) => {
  const { t } = useTranslation();
  const { inputRef, ...other } = props;
  return /* @__PURE__ */ jsx(
    MaskedInput,
    {
      ...other,
      ref: (ref) => {
        inputRef == null ? void 0 : inputRef(ref ? ref.inputElement : null);
      },
      mask: [/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
      placeholderChar: " ",
      placeholder: t("date_placeholder"),
      showMask: false
    }
  );
};
export {
  MaskedDateInput
};
